// extracted by mini-css-extract-plugin
export default {"header":"MainNav_header__lxjdu","container":"MainNav_container__E2pMH","logo":"MainNav_logo__g2LwM","Menu":"MainNav_Menu__syJK-"};